export default __webpack_public_path__ + "static/media/help_sub-photo_sample1.321e615c.png";